import React, { useState } from 'react';
import profilepie from '../../assets/profile-pie.png';
import EditMyPrivacyModal from "./editProfileModals/EditMyPrivacyModal";

function ProfileCompletion(props) {
    const [ myPrivacyModal, setMyPrivacyModal ] = useState(false);
    const toggleMyPrivacyModal = () => setMyPrivacyModal(!myPrivacyModal);
    return (
    <div className="ht-250">
        <div className="profile-completion-header wd-pct-100 text-center">Profile Completion Status</div>
            <div className="wd-pct-100 text-center mg-b-20">
                <img src={profilepie} style={{height: "110px"}}></img>
            </div>
            <div className="text-center">
                <button className="btn btn-primary wd-pct-80 " onClick={toggleMyPrivacyModal}>Set Privacy</button>
                <EditMyPrivacyModal modal={myPrivacyModal} toggle={toggleMyPrivacyModal}  />
            </div>
    </div>
        
    );
  }

export default ProfileCompletion